module.exports = __webpack_public_path__ + "img/horizontal_3_6_pp1_5.d2d83426.png";